import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './Nav.module.scss';
import Image from '../../Image';
import menu from '../../../assets/nav/menu.png';
import EmployeeNav from './EmployeeNav';
import RailsMobileSchoolNav from './RailsMobileSchoolNav';
import useBreakpoints from '../../../hooks/use-breakpoints';

// School type is now passed as a prop (schoolTypeName) from the Rails layout
// instead of using hardcoded arrays of school IDs

const RailsNav = ({ currentUser, schoolTypeName }) => {
  const breakpoint = useBreakpoints();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setIsLoginOpen(false);
  }, [isOpen]);

  useEffect(() => {
    if (!isLoginOpen) return;

    setIsOpen(false);
  }, [isLoginOpen]);


  const [isOpenYB, setIsOpenYB] = useState(false);
  const [isLoginOpenYB, setIsLoginOpenYB] = useState(false);
  const [isYBGradePagesOpen, setIsYBGradePagesOpen] = useState(false);
  const [isClassPicturesOpen, setIsClassPicturesOpen] = useState(false);

  useEffect(() => {
    if (!isOpenYB) return;

    setIsLoginOpenYB(false);
  }, [isOpenYB]);

  useEffect(() => {
    if (!isLoginOpenYB) return;

    setIsOpenYB(false);
  }, [isLoginOpenYB]);

  if (currentUser.employee || currentUser.photographer || currentUser.admin) return <EmployeeNav currentUser={currentUser} />;

  // Switch to mobile nav on smaller screens
  if (['lg', 'md', 'sm'].includes(breakpoint)) {
    return <RailsMobileSchoolNav currentUser={currentUser} schoolTypeName={schoolTypeName} />;
  }

  return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        noPrint: true,
        'rails-nav': true,
      })}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsLoginOpen(!isLoginOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isLoginOpen,
          })}
        >
          <li>
            <a href="/pages/home">
              Home Page
            </a>
          </li>
        </ul>
      </div>
      <ul className={styles.nav}>
        <li className={styles.dropdown}>
          <a href="/contracts" rel="noopener noreferrer" target="_blank">
            Contract
          </a>
        </li>
        <li className={styles.dropdown}>
          <a href={`/schools/schooledit?id=${currentUser.school_id}`}  target="_blank">
            School Data/Jobs
          </a>
        </li>
        <li className={styles.dropdown}>
          <a href="/school_files" target="_blank" rel="noreferrer">
            Files
          </a>
          {/* <button
            className={styles.button}
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            Files
          </button>
          <ul
            className={cn({
              [styles.dropdownMenu]: true,
              [styles.hidden]: !isOpen,
            })}
          >
            <li>
              <a href={`/school_files/outgoing_files?q[school_id_eq]=${currentUser.school_id}`}>To Shoob Photo</a>
            </li>
            <li>
              <a href={`/school_files/incoming_files?q[school_id_eq]=${currentUser.school_id}`}>From Shoob Photo</a>
            </li>
          </ul> */}
        </li>
        {schoolTypeName === 'High School' && (
          <li>
            <a href="https://admin.shoobphoto.com/senior-status" rel="noopener noreferrer" target="_blank">
              Senior Portraits
            </a>
          </li>
        )}
        <li>
          <a href="/export/students">Students</a>
        </li>
        {schoolTypeName !== 'High School' && schoolTypeName !== 'Middle School' && (
          <li className={styles.dropdown}>
            <button
              className={styles.button}
              onClick={() => setIsClassPicturesOpen(!isClassPicturesOpen)}
              type="button"
            >
              Class Pictures
            </button>
            <ul
              className={cn({
                [styles.dropdownMenu]: true,
                [styles.hidden]: !isClassPicturesOpen,
              })}
            >
              <li>
                <a href={`/schools/${currentUser.school_id}/class_pictures`}>Correct Class Pictures</a>
              </li>
              <li>
                <a href={`/schools/${currentUser.school_id}/correction_status`}>View Correction Status</a>
              </li>
            </ul>
          </li>
        )}
        <li>
          <a href="/awards">
            Awards
          </a>
        </li>

        <li className={styles.dropdown}>
          <button
            className={styles.button}
            onClick={() => setIsOpenYB(!isOpenYB)}
            type="button"
          >
            Yearbooks
          </button>
          <ul
            className={cn({
              [styles.dropdownMenu]: true,
              [styles.hidden]: !isOpenYB,
            })}
          >
            <li>
              <a href={`/yearbook_requests/new`}>Sign Up</a>
            </li>
            <li>
              <a href={`/order_packages`}>Sales</a>
            </li>
            <li>
              <a href="/order_packages/choose_yearbook_sales_or_submit">
                Class Pages by Teacher
              </a>
            </li>
            <li className={styles.dropdown}>
              <button
                className={styles.buttonleft}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsYBGradePagesOpen(!isYBGradePagesOpen);
                }}
                type="button"
              >
                Class Pages by Grade
              </button>
              <ul
                className={cn({
                  [styles.dropdownMenu]: true,
                  [styles.submenu]: true,
                  [styles.hidden]: !isYBGradePagesOpen,
                })}
                  ><li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>Default</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=5`}>5 photos per row</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=6`}>6 photos per row</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>7 photos per row</a></li>
                </ul>
            </li>
            <li>
              <a href={`/yearbooks/templates`}>Canva Cover Templates</a>
            </li>
            <li>
              <a href={`/yearbook_submissions/new?cover_only=yes`}>Submit Cover</a>
            </li>
            <li>
              <a href={`/yearbook_submissions/new?cover_only=no`}>Submit Yearbook</a>
            </li>
          </ul>
        </li>

        <li>
          <a href="/school_resources">
            Resources for Schools
          </a>
        </li>
        <li>
          <a rel="nofollow" data-method="delete" href="/users/sign_out">Logout</a>
        </li>
      </ul>
    </nav>
  );
};

export default RailsNav;
